module.exports = __webpack_public_path__ + "static/media/smm-horizontal.d9ea5e77.png";